import api from "@/services/api";

const endpoint = () => `/lab-sso`;

const labSsoService = {};

labSsoService.getRedirectUrl = function (patientId) {
  return api
    .post(`${endpoint()}/redirect`, { patientId })
    .then((res) => res.data);
};

export default labSsoService;
